export default __webpack_public_path__ + "assets/icon-error.1c68c43a.webp";